import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Button, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { addNewLessonPlan, getDivisionStart, updateLessonPlan } from 'store/actions';
import { getSubjectListStart } from 'store/SubjectRequest/action';
import * as Yup from "yup"
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";
import moment from 'moment';

const CreateLessonPlanModal = ({ isEdit, setEdit, isShowModal, setIsShowModal, selectedLesson }) => {
    const dispatch = useDispatch();

    const { subjectList } = useSelector(state => state.SubjectRequest);

    const { acadID, division } = useSelector(state => state.CommonReducer)

    console.log(selectedLesson)
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: isEdit
            ?
            {
                id: selectedLesson.id,
                classdiv_id: selectedLesson.classdiv_id,
                subject_id: selectedLesson.subject_id,
                lesson_name: selectedLesson.lesson_name,
                topic: selectedLesson.topic,
                no_of_req_periods: selectedLesson.no_of_req_periods,
                planned_date_from: selectedLesson.planned_date_from,
                planned_date_to: selectedLesson.planned_date_to,
                completion_date: selectedLesson.completion_date,
                published: 1,
                published_date: moment(new Date()).format("YYYY-MM-DD"),
                published_by: selectedLesson.published_by,
                files: selectedLesson.files,
            }

            : {
                classdiv_id: "",
                subject_id: "",
                lesson_name: "",
                topic: "",
                no_of_req_periods: "",
                planned_date_from: "",
                planned_date_to: "",
                completion_date: "",
                published: 0,
                published_date: "",
                published_by: "",
                files: null,
            },
        validationSchema: Yup.object({
            classdiv_id: Yup.string().required("Please Select Class and Divisions"),
            subject_id: Yup.string().required("Please Select Subject"),
            lesson_name: Yup.string().required("Please Enter Lesson Name"),
            topic: Yup.string().required("Please Enter topic"),
            no_of_req_periods: Yup.string().required("Please Enter no of period"),
            planned_date_from: Yup.string().required("Please Select planned start date"),
            planned_date_to: Yup.string().required("Please select planned end date"),


        }),
        onSubmit: values => {
            if (isEdit) {
                dispatch(updateLessonPlan(values))
                setIsShowModal(false)
                setEdit(false)
                validation.resetForm()
            } else {
                console.log(values)
                const formDataManual = new FormData();

                formDataManual.append("classdiv_id", values.classdiv_id);
                formDataManual.append("subject_id", values.subject_id);
                formDataManual.append("lesson_name", values.lesson_name);
                formDataManual.append("topic", values.topic);
                formDataManual.append("no_of_req_periods", values.no_of_req_periods);
                formDataManual.append("planned_date_from", values.planned_date_from);
                formDataManual.append("planned_date_to", values.planned_date_to);
                formDataManual.append("completion_date", values.completion_date);
                formDataManual.append("published", values.published); // assuming it's a boolean or "0"/"1"
                formDataManual.append("published_date", values.published_date);
                formDataManual.append("published_by", values.published_by);
                formDataManual.append("files", values.files); // make sure `files` is a single File object


                dispatch(addNewLessonPlan(formDataManual))
                setIsShowModal(false)
                validation.resetForm()
            }
        },
    })

    useEffect(() => {
        const acad_id = localStorage.getItem("acad_id")
        dispatch(getDivisionStart({
            acad_id
        }))
    }, [])

    useEffect(() => {
        if (validation.values.classdiv_id) {
            const acad_id = localStorage.getItem("acad_id");
            dispatch(
                getSubjectListStart({
                    acadId: acad_id,
                    classDivId: validation.values.classdiv_id,
                })
            );
        }
    }, [validation.values.classdiv_id]);


    return (
        <Modal isOpen={isShowModal} toggle={() => setIsShowModal(false)}>
            <ModalHeader toggle={() => setIsShowModal(false)}>{isEdit ? "Update Lesson Plan" : "Create New Lesson Plan"}</ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                    }}>
                    <FormGroup>
                        <Label for='classdiv_id'>Select class and division</Label>
                        <Input
                            name='classdiv_id'
                            id='classdiv_id'
                            type='select'
                            placeholder='SELECT CLASS AND DIVISION'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            disabled={isEdit}
                            value={validation.values.classdiv_id || ""}
                            invalid={
                                validation.touched.classdiv_id && validation.errors.classdiv_id
                                    ? true
                                    : false
                            }
                        >
                            <option>SELECT CLASS AND DIVISION</option>
                            {division.map((data, index) => (<option key={index} value={data.class}>{data.div_name}</option>))}
                        </Input>
                        {validation.touched.classdiv_id && validation.errors.classdiv_id ? (
                            <FormFeedback type="invalid">
                                {validation.errors.classdiv_id}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>


                    <FormGroup>
                        <Label for='subject_id'>Select Subjects</Label>
                        <Input
                            name='subject_id'
                            id='subject_id'
                            type='select'
                            placeholder='SELECT SUBJECT'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.subject_id || ""}
                            disabled={isEdit}
                            invalid={
                                validation.touched.subject_id && validation.errors.subject_id
                                    ? true
                                    : false
                            }
                        >
                            <option>SELECT SUBJECT</option>
                            {subjectList.map((data, index) => (<option key={index} value={data.id}>{data.subject}</option>))}
                        </Input>

                        {validation.touched.subject_id && validation.errors.subject_id ? (
                            <FormFeedback type="invalid">
                                {validation.errors.subject_id}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>

                    <FormGroup>
                        <Label for='lesson_name'>Enter Lesson Name</Label>
                        <Input
                            name='lesson_name'
                            id='lesson_name'
                            type='text'
                            placeholder='Enter Lesson name'
                            disabled={isEdit}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.lesson_name || ""}
                            invalid={
                                validation.touched.lesson_name && validation.errors.lesson_name
                                    ? true
                                    : false
                            }
                        />

                        {validation.touched.lesson_name && validation.errors.lesson_name ? (
                            <FormFeedback type="invalid">
                                {validation.errors.lesson_name}
                            </FormFeedback>
                        ) : null}

                    </FormGroup>


                    <FormGroup>
                        <Label for='topic'>Enter Topics</Label>
                        <Input
                            name='topic'
                            id='topic'
                            type='textarea'
                            placeholder='Enter TOPICS'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            disabled={isEdit}
                            value={validation.values.topic || ""}
                            invalid={
                                validation.touched.topic && validation.errors.topic
                                    ? true
                                    : false
                            }
                        />

                        {validation.touched.topic && validation.errors.topic ? (
                            <FormFeedback type="invalid">
                                {validation.errors.topic}
                            </FormFeedback>
                        ) : null}

                    </FormGroup>

                    <FormGroup>
                        <Label for='no_of_req_periods'>Select Req No of Periods</Label>
                        <Input
                            name='no_of_req_periods'
                            id='no_of_req_periods'
                            type='select'
                            placeholder='Select No of Periods'
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.no_of_req_periods || ""}
                            disabled={isEdit}
                            invalid={
                                validation.touched.no_of_req_periods && validation.errors.no_of_req_periods
                                    ? true
                                    : false
                            }
                        >
                            <option>Select NO OF PERIODS</option>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((data, index) => (<option key={index} value={data}>{data}</option>))}
                        </Input>


                        {validation.touched.no_of_req_periods && validation.errors.no_of_req_periods ? (
                            <FormFeedback type="invalid">
                                {validation.errors.no_of_req_periods}
                            </FormFeedback>
                        ) : null}

                    </FormGroup>


                    <FormGroup>
                        <Label for='planned_date_from'>Select Planned Date From</Label>
                        <FlatPickr
                            className="form-control"
                            name="planned_date_from"
                            placeholder="Select Planned Date From"
                            options={{
                                dateFormat: "d/m/Y",
                            }}
                            value={
                                validation.values.planned_date_from
                                    ? moment(validation.values.planned_date_from).format("DD-MM-YYYY")
                                    : null
                            }
                            disabled={isEdit}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.planned_date_from && validation.errors.planned_date_from
                                    ? true
                                    : false
                            }
                             onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                validation.setFieldValue(
                                    "planned_date_from",
                                    moment(selectedDates[0]).format("YYYY-MM-DD")
                                );
                            }}
                        />


                        {validation.errors.planned_date_from ? (
                            <p
                                className="text-danger"
                                style={{ fontSize: "10px" }}>
                                {validation.errors.planned_date_from}
                            </p>
                        ) : null}

                    </FormGroup>


                    <FormGroup>
                        <Label for='planned_date_to'>Select Planned Date To</Label>
                        {console.log(validation.values.planned_date_to)}
                        <FlatPickr
                            className="form-control"
                            name="planned_date_to"
                            placeholder="Select Planned Date From"
                            options={{
                                dateFormat: "d/m/Y",
                            }}
                            value={
                                validation.values.planned_date_to
                                    ? moment(validation.values.planned_date_to).format("DD-MM-YYYY")
                                    : null
                            }
                            disabled={isEdit}

                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                validation.setFieldValue(
                                    "planned_date_to",
                                    moment(selectedDates[0]).format("YYYY-MM-DD")
                                );
                            }}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.planned_date_to &&
                                    validation.errors.planned_date_to
                                    ? true
                                    : false
                            }
                        />




                        {validation.errors.planned_date_to ? (
                            <p
                                className="text-danger"
                                style={{ fontSize: "10px" }}>
                                {validation.errors.planned_date_to}
                            </p>
                        ) : null}
                    </FormGroup>


                    {isEdit ? <><FormGroup>
                        <Label for='completion_date'>Select Completion Date</Label>
                        <FlatPickr
                            className="form-control"
                            name="completion_date"
                            placeholder="Select Completion Date"
                            options={{
                                dateFormat: "d/m/Y"
                            }}
                            value={validation.values.completion_date && moment(validation.values.completion_date).format("DD-MM-YYYY")}
                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                validation.setFieldValue("completion_date", moment(selectedDates[0]).format("YYYY-MM-DD"));
                            }}

                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.completion_date && validation.errors.completion_date
                                    ? true
                                    : false
                            }
                        />


                        {validation.errors.completion_date ? (
                            <p
                                className="text-danger"
                                style={{ fontSize: "10px" }}>
                                {validation.errors.completion_date}
                            </p>
                        ) : null}

                    </FormGroup>
                    </> : null}

                    <FormGroup>
                        <Label for="files">Upload File</Label>
                        <Input
                            id="files"
                            name="files"
                            type="file"
                            onBlur={validation.handleBlur}
                            onChange={(event) => {
                                validation.setFieldValue("files", event.currentTarget.files[0]);
                            }}
                            className={validation.touched.files && validation.errors.files ? 'is-invalid' : ''}

                        />
                        {validation.errors.files ? (
                            <p
                                className="text-danger"
                                style={{ fontSize: "10px" }}>
                                {validation.errors.files}
                            </p>
                        ) : null}
                    </FormGroup>

                    <FormGroup>
                        <Button type='submit' color='primary'>{isEdit ? "Update & Publish" : "Create Lesson Plan"}</Button>
                    </FormGroup>

                </Form>
            </ModalBody>
        </Modal>
    )
}

export default CreateLessonPlanModal